import React from "react"
import { Link } from "react-router-dom"
import { Input, Button, Table, Space, Select, DatePicker, Carousel } from 'antd'
import Modal from "antd/lib/modal/Modal"
import { FormInstance } from "antd/lib/form"
import { SearchOutlined, RedoOutlined, } from '@ant-design/icons'
import { axiosTable, baseAxiosNoInfo } from '../../tool/axios'
import { SelectStores } from '../../component/common/Selects'
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import moment from 'moment'

import './css/ChankangOrder.css'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

interface FetchOtherParams {
    store_id: string | undefined,
    customer_name: string | undefined,
    customer_phone: string | undefined,
    order_code: undefined,
    create_start_date: undefined,
    create_end_date: undefined,
    deal_start_date: undefined,
    deal_end_date: undefined,
    employee_id_adviser: string | undefined,
    employee_id_recover: string | undefined,
    review_status: undefined,
    final_review_status: undefined
}

interface State {
    data: object[],
    adviseEmployeeList: [],
    recoverEmployeeList: [],
    loading: boolean,

    pagination: {
        current: number,
        pageSize: number,
        total: number,
        showSizeChanger: boolean
    },

    formParams: {
        item_type: string | null
    },

    offShelfVisible: boolean,
    addVisible: false,
    fetchOtherParams: FetchOtherParams,
    rangeDate: any,
    dealDate: any,
    confrimMoneyVisible: boolean,
    activeRecord: any,
    imageVisble: boolean,
    imageList: [],
    imageVisbleType: string,
    permissionList: string[]
}

const fetchFormParams = {
    store_id: undefined,
    customer_name: undefined,
    customer_phone: undefined,
    order_code: undefined,
    create_start_date: undefined,
    create_end_date: undefined,
    deal_start_date: undefined,
    deal_end_date: undefined,
    employee_id_adviser: undefined,
    employee_id_recover: undefined,
    review_status: undefined,
    final_review_status: undefined
}

export default class OrderList extends React.Component {
    state: State = {
        data: [],
        adviseEmployeeList: [],
        recoverEmployeeList: [],
        loading: false,

        pagination: {
            current: 1,
            pageSize: 8,
            total: 0,
            showSizeChanger: false
        },

        fetchOtherParams: {
            ...fetchFormParams
        },

        formParams: {
            item_type: null
        },

        offShelfVisible: false,
        addVisible: false,
        rangeDate: null,
        dealDate: null,
        confrimMoneyVisible: false,
        activeRecord: {},
        imageVisble: false,
        imageList: [],
        imageVisbleType: '',
        permissionList: []
    }

    formRef = React.createRef<FormInstance>()

    componentDidMount() {
        this.setState({
            permissionList: getPermission()
        })

        const { pagination, fetchOtherParams } = this.state

        // 初始化下单日期
        this.handleDateChange([moment().startOf('month'), moment().endOf('month')])
        // 初始化获取产康顾问和产康师
        this.getEmployeeList(4, '')
        this.getEmployeeList(5, '')

        this.fetch({ pagination, fetchOtherParams })
    }

    getEmployeeList = (type: any, id: any) => {
        baseAxiosNoInfo('/global/employee_list_by_position', { params: { department_id: id, position_number: type } }).then((res: any) => {
            if (res) {
                if (type == 4) {
                    this.setState({
                        adviseEmployeeList: res
                    })

                } else {
                    this.setState({
                        recoverEmployeeList: res
                    })
                }
            }
        })
    }

    handleInputChange(value: string, attr: string) {
        let { fetchOtherParams }: { fetchOtherParams: any } = this.state
        fetchOtherParams[attr] = value

        this.setState({ fetchOtherParams })
    }

    handleSelectChange(value: string, attr: string) {
        let { fetchOtherParams }: { fetchOtherParams: any } = this.state
        fetchOtherParams[attr] = value

        this.setState({ fetchOtherParams })
    }

    handleSelectStoreChange(value: string, attr: string) {
        let { fetchOtherParams }: { fetchOtherParams: any } = this.state
        fetchOtherParams[attr] = value

        this.setState({ fetchOtherParams })
        this.getEmployeeList(4, value)
        this.getEmployeeList(5, value)
    }

    handleDateChange(dateArr: any) {
        let { fetchOtherParams }: { fetchOtherParams: any } = this.state

        if (dateArr) {
            fetchOtherParams.create_start_date = dateArr[0].format('YYYY-MM-DD')
            fetchOtherParams.create_end_date = dateArr[1].format('YYYY-MM-DD')

        } else {
            fetchOtherParams.create_start_date = undefined
            fetchOtherParams.create_end_date = undefined
        }

        this.setState({ rangeDate: dateArr, fetchOtherParams })
    }

    handleDealDateChange(dateArr: any) {
        let { fetchOtherParams }: { fetchOtherParams: any } = this.state

        if (dateArr) {
            fetchOtherParams.deal_start_date = dateArr[0].format('YYYY-MM-DD')
            fetchOtherParams.deal_end_date = dateArr[1].format('YYYY-MM-DD')

        } else {
            fetchOtherParams.deal_start_date = undefined
            fetchOtherParams.deal_end_date = undefined
        }

        this.setState({ dealDate: dateArr, fetchOtherParams })
    }

    handleAgreement(el: any, type: any) {
        let arr = []
        if (type == '1') {
            arr = el.agreement_pic_list ? el.agreement_pic_list.split(',') : []

        } else {
            arr = el.pay_pic_list ? el.pay_pic_list.split(',') : []
        }

        this.setState({
            imageVisble: true,
            imageVisbleType: type,
            imageList: arr
        })
    }

    handleSearch() {
        let { pagination, fetchOtherParams } = this.state
        pagination.current = 1

        this.setState({ pagination }, () => {
            this.fetch({ pagination, fetchOtherParams })
        })
    }

    handleTableChange = (antPagination: any) => {
        const { fetchOtherParams, pagination } = this.state
        pagination.current = antPagination.current

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    fetch({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/chankang_center/order_list/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            if (response) {
                const { pagination } = this.state
                pagination.total = response.total
                pagination.pageSize = response.size
                pagination.current = response.current

                this.setState({
                    pagination,
                    data: response.records
                })
            }
        })
    }

    // 导出
    exportExcel() {
        let { pagination, fetchOtherParams } = this.state
        const iPagination: any = { ...pagination }

        axiosTable.get('/chankang_center/order_list/export', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    resetForm() {
        let { pagination, fetchOtherParams } = this.state
        pagination.current = 1

        fetchOtherParams = {
            store_id: undefined,
            customer_name: undefined,
            customer_phone: undefined,
            order_code: undefined,
            create_start_date: undefined,
            create_end_date: undefined,
            deal_start_date: undefined,
            deal_end_date: undefined,
            employee_id_adviser: undefined,
            employee_id_recover: undefined,
            review_status: undefined,
            final_review_status: undefined
        }

        this.setState({
            pagination,
            fetchOtherParams,
            rangeDate: null,
            dealDate: null
        })

        this.fetch({ pagination, fetchOtherParams })
    }

    offShelf() {
        this.setState({ offShelfVisible: true })
    }

    render() {
        let { store_id, customer_name, customer_phone, order_code, employee_id_adviser, employee_id_recover, review_status, final_review_status } = this.state.fetchOtherParams
        let permissionList = this.state.permissionList

        const getAdviseEmployeeList = this.state.adviseEmployeeList.map((el: any) => (<Option value={el.employee_id} key={el.employee_id}  >{el.user_name}</Option>))
        const getRecoverEmployeeList = this.state.recoverEmployeeList.map((el: any) => (<Option value={el.employee_id} key={el.employee_id}  >{el.user_name}</Option>))

        return (<div className="common-page">
            {/* 产康中心 -> 产康项目管理 -> 产康订单管理 */}
            <BreadCrumb position={['产康中心', '产康订单管理']} />

            <div className="common-top-form">
                <Space direction="horizontal" wrap>
                    <div style={{ marginRight: 8, marginBottom: 12 }}>
                        <SelectStores valueProp="id" value={store_id} onChange={(value: string) => { this.handleSelectStoreChange(value, 'store_id') }} />
                    </div>
                    <Input style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={customer_name} placeholder="客户名称" onChange={(e: { target: { value: string } }) => { this.handleInputChange(e.target.value, 'customer_name') }} />
                    <Input style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={customer_phone} placeholder="客户手机号" onChange={(e: { target: { value: string } }) => { this.handleInputChange(e.target.value, 'customer_phone') }} />
                    <Input style={{ marginRight: 8, marginBottom: 12, width: '160px' }} value={order_code} placeholder="订单编号" onChange={(e: { target: { value: string } }) => { this.handleInputChange(e.target.value, 'order_code') }} />

                    <RangePicker style={{ marginRight: 8, marginBottom: 12, width: '250px' }} placeholder={['下单开始日期', '下单结束日期']} onChange={this.handleDateChange.bind(this)} value={this.state.rangeDate} />
                    <RangePicker style={{ marginRight: 8, marginBottom: 12, width: '250px' }} placeholder={['付款开始日期', '付款结束日期']} onChange={this.handleDealDateChange.bind(this)} value={this.state.dealDate} />

                    <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} value={employee_id_adviser} onChange={(value: string) => { this.handleSelectChange(value, 'employee_id_adviser') }} placeholder="产康顾问">
                        {getAdviseEmployeeList}
                    </Select>
                    <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} value={employee_id_recover} onChange={(value: string) => { this.handleSelectChange(value, 'employee_id_recover') }} placeholder="产康师">
                        {getRecoverEmployeeList}
                    </Select>

                    <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} value={review_status} onChange={(value: string) => { this.handleSelectChange(value, 'review_status') }} placeholder="初审状态" >
                        <Option value={0} key={0}>待审核</Option>
                        <Option value={1} key={1}>审核通过</Option>
                        <Option value={2} key={2}>审核不通过</Option>
                    </Select>
                    <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} value={final_review_status} onChange={(value: string) => { this.handleSelectChange(value, 'final_review_status') }} placeholder="终审状态" >
                        <Option value={0} key={0}>待审核</Option>
                        <Option value={1} key={1}>审核通过</Option>
                        <Option value={2} key={2}>审核不通过</Option>
                    </Select>
                </Space>

                <div style={{ marginTop: 10 }}>
                    {permissionList.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={this.handleSearch.bind(this)}>查询</Button>}
                    <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={this.resetForm.bind(this)} icon={<RedoOutlined />}>重置</Button>
                    {permissionList.includes('添加') && <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" ><Link to={"/ck_order_list_add"}>添加</Link></Button>}
                    {/* <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={this.exportExcel.bind(this)} type="dashed" >导出</Button> */}
                </div>
            </div>

            <div className="common-main">
                <Table dataSource={this.state.data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={this.state.pagination} onChange={this.handleTableChange}>
                    <Column
                        fixed
                        title="操作"
                        key="action"
                        render={(text, record: any) => (
                            <Space size="middle">
                                {permissionList.includes('查看') && <Button type="link"><Link to={"/ck_order_detail/" + record.order_id + '/' + 'false'}>查看</Link></Button>}
                                {(record.review_status != 1 || record.final_review_status === 2) && <Button type="link"><Link to={"/ck_order_list_update/" + record.order_id}>编辑</Link></Button>}
                            </Space>
                        )}
                    />

                    <Column title="门店" dataIndex="store_name" key="store_name" />
                    <Column title="客户名称" dataIndex="customer_name" key="customer_name" />
                    <Column title="客户手机号" dataIndex="customer_phone" key="customer_phone" />
                    <Column title="入住状态" dataIndex="check_in_status_desc" key="check_in_status_desc" />
                    <Column title="入住时间" dataIndex="check_in_time" key="check_in_time" />
                    <Column title="出所日期" dataIndex="check_out_time" key="check_out_time" />
                    <Column title="入住房号" dataIndex="room_number" key="room_number" />
                    <Column title="订单编号" dataIndex="order_code" key="order_code" />
                    <Column title="下单时间" dataIndex="create_date" key="create_date" />
                    <Column title="付款日期" dataIndex="deal_date" key="deal_date" />
                    <Column title="产康购买项目数" dataIndex="chankang_buy_item_count" key="chankang_buy_item_count" />
                    <Column title="产康赠送项目数" dataIndex="gift_chankang_item_count" key="gift_chankang_item_count" />
                    <Column title="月子赠送项目数" dataIndex="gift_yuezi_item_count" key="gift_yuezi_item_count" />
                    <Column title="产康顾问" dataIndex="employee_name_adviser" key="employee_name_adviser" />
                    <Column title="产康师" dataIndex="employee_name_recover" key="employee_name_recover" />
                    <Column title="订单状态" dataIndex="order_status_desc" key="order_status_desc" />
                    <Column title="订单金额" dataIndex="init_deal_amount" key="init_deal_amount" />
                    <Column title="成交金额" dataIndex="actually_deal_amount" key="actually_deal_amount" />

                    <Column title="初审状态" dataIndex="review_status" key="review_status" render={(v: any) => {
                        if (v == 0) {
                            return '待审核'

                        } else if (v == 1) {
                            return '审核通过'

                        } else {
                            return '审核不通过'
                        }
                    }} />
                    <Column title="终审状态" dataIndex="final_review_status" key="final_review_status" render={(v: any) => {
                        if (v == 0) {
                            return '待审核'

                        } else if (v == 1) {
                            return '审核通过'

                        } else {
                            return '审核不通过'
                        }
                    }} />
                    <Column title="备注" dataIndex="remark" key="remark" />

                    <Column
                        title="收款凭证"
                        key="agreement_pic_list"
                        render={(text, record: any) => (
                            <Space size="middle">
                                <Button type="link" onClick={this.handleAgreement.bind(this, record, '2')}>查看收款</Button>
                            </Space>
                        )}
                    />
                </Table>
            </div>

            {/* 图片预览 */}
            <Modal title={this.state.imageVisbleType == '1' ? '合同凭证预览' : '收款凭证预览'} visible={this.state.imageVisble} onCancel={() => { this.setState({ imageVisble: false }) }} footer={null}>
                <Carousel>
                    {this.state.imageList.length && this.state.imageList.map((el: any, index: any) => (
                        <img key={index} src={el}></img>
                    ))}
                </Carousel>
            </Modal>
        </div>)
    }
}